define('SageDotCom/Components/Content/Buttons/ChatRoutingWindow',[
    "jquery",
    "SageDotCom/DataLayer/Events/Ccaas/ccaasAltEvent",
    "SageDotCom/DataLayer/Events/Ccaas/ccaasTracking",
    "eventManager"
], function ($, CcaasTracking) {
    function ChatRoutingWindow() {
        const $startWebMsgBtn = $(".open-live-chat");
        const $tooltip = $(".cs-help-tooltip");
        const $ccaasContainer = $(".ccaas-container");
        const $welcomeDialog = $(".ccaas-chat-dialog-welcome");
        const $chooseDialog = $(".ccaas-chat-dialog-choose");

        //Helper Utils
        function waitForGenesys(selector, callback, maxTime) {
            var startTime = Date.now();
            var interval = setInterval(function () {
                    if (window.Genesys !== undefined && $(selector)) {
                        clearInterval(interval);
                        callback();
                    } else {
                        if (Date.now() - startTime > maxTime) {
                            clearInterval(interval);
                        }
                    }
                },
                100
            );
        }

        function waitForElement(selector, callback, maxTime) {
            var startTime = Date.now();
            var interval = setInterval(function () {
                    if ($(selector).is(":visible")) {
                        clearInterval(interval);
                        callback();
                    } else {
                        if (Date.now() - startTime > maxTime) {
                            clearInterval(interval);
                        }
                    }
                },
                100
            );
        }

        function openTooltip() {
            $tooltip.addClass("tooltip-open");
            $startWebMsgBtn.addClass("hidden");
            setTimeout(() => $tooltip.removeClass("tooltip-open"), 20000);
        }

        function closeTooltip() {
            $tooltip.remove();
        }

        function closeChat() {
            $ccaasContainer.removeClass("chat-open chat-step-1 chat-step-2 ccaas-minimized");
            $welcomeDialog.addClass("cx-hidden");
        }

        function minimizeChat() {
            $ccaasContainer.removeClass("chat-open").addClass("ccaas-minimized");
            $welcomeDialog.addClass("cx-hidden");
        }

        function handleTrackingEvent(eventType) {
            new CcaasTracking(eventType).trigger();
        }

        function setupEventHandlers() {
            $tooltip.find(".close, .cs-button").on("click touch", closeTooltip);

            $ccaasContainer.find(".ccaas-header .ccaas-close").on("click", closeChat);
            $ccaasContainer.find(".ccaas-header .ccaas-minimize").on("click", minimizeChat);

            $tooltip.find(".close").on("click", () => handleTrackingEvent("live_chat_callout_rejected"));
            $ccaasContainer.find(".open-welcome-screen").on("click", () => handleTrackingEvent("live_chat_welcome_screen"));
            $welcomeDialog.find(".ccaas-body .choose-option").on("click", () => handleTrackingEvent("live_chat_contact_options"));
            $welcomeDialog.find(".ccaas-body .button-group a").on("click", () => handleTrackingEvent("live_chat_external_link"));

            $welcomeDialog.find(".choose-option").on("click", function () {
                $ccaasContainer.removeClass("chat-step-1").addClass("chat-open chat-step-2");
            });

            $chooseDialog.find(".button--secondary").on("click", function () {
                $ccaasContainer.removeClass("chat-step-2").addClass("chat-open chat-step-1");
            });

            $startWebMsgBtn.on("click", function () {
                $ccaasContainer.removeClass("chat-open chat-step-1 chat-step-2");
                window.Genesys("command", "Messenger.open");
            });

            $(".ccaas-btn.btn-web-chat").on("click", function () {
                $welcomeDialog.removeClass("cx-hidden");
                closeTooltip();

                if ($ccaasContainer.hasClass("chat-step-2") || $ccaasContainer.hasClass("chat-step-1")) {
                    $ccaasContainer.addClass("chat-open").removeClass("ccaas-minimized");
                } else {
                    $ccaasContainer.addClass("chat-open chat-step-1").removeClass("ccaas-minimized");
                }
            });
        }

        openTooltip();
        setupEventHandlers();

        //Web Messenger
        waitForGenesys('link[href*=\"_web-chat-genesys.min.css\"]', function () {
            $ccaasContainer.removeClass("hidden");
            $startWebMsgBtn.removeClass("hidden");
        }, 20000);

        waitForElement('.genesys-app', function () {
            if (window.Genesys !== undefined) {
                //Monitor the Genesys iFrame and check for if it is open or closed & hide/show button.
                const genesysObserver = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        if (mutation.target.classList.contains('genesys-mxg-conversation')) {
                            $ccaasContainer.addClass("hidden");
                        } else if (!mutation.target.classList.contains('genesys-mxg-conversation')) {
                            $ccaasContainer.removeClass("hidden");
                        }
                    });
                });

                const iFrameGenesys = document.querySelector('.genesys-mxg-container-frame');
                genesysObserver.observe(iFrameGenesys, { attributes: true, attributeFilter: ['class'] });
            }
        }, 20000);
    }

    ChatRoutingWindow.init = function init(args) {
        return args.IsExperienceEditorEditing ? null : new ChatRoutingWindow(args.hidePreChatForm);
    };

    return ChatRoutingWindow;
});

